var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dispute !== null)?_c('div',{staticClass:"status",class:{
    'pending-status': _vm.dispute.status === 'PENDING' || _vm.dispute.status === 'INQUIRY'
      || _vm.dispute.status === 'REQUEST_FOR_INFORMATION' || _vm.dispute.status === 'NOTIFICATION_OF_CHARGEBACK',
    'won-status': _vm.dispute.status === 'WON',
    'lost-status': _vm.dispute.status === 'LOST' || _vm.dispute.status === 'ACCEPTED',
    'responded-status': _vm.dispute.status === 'RESPONDED' || _vm.dispute.status === 'SUSPECTED_FRAUD'
  }},[_vm._v(" "+_vm._s(_vm.$t('disputes.status.' + _vm.dispute.status))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }